import styled from 'styled-components'
import { Link } from '@tanstack/react-router'

import { Button } from './Button'

export const ErrorBoundaryWrapper = styled.div`
  background-color: rgb(250, 250, 250);
  height: 100vh;
  width: 100vw;
  padding: 8px 24px;
  position: fixed;
  z-index: 100000;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  h1,
  h2,
  p {
    margin: 0 0 8px;
  }
`

export const NotFound = () => {
  return (
    <ErrorBoundaryWrapper>
      <h2>Page Not Found!</h2>
      <p>The page you are looking for does not exist.</p>
      <Button as={Link} variant="primary" to="/">
        Go Back
      </Button>
    </ErrorBoundaryWrapper>
  )
}
